import { render, staticRenderFns } from "./viewUrl.vue?vue&type=template&id=08acff75&scoped=true&"
import script from "./viewUrl.vue?vue&type=script&lang=js&"
export * from "./viewUrl.vue?vue&type=script&lang=js&"
import style0 from "./viewUrl.vue?vue&type=style&index=0&id=08acff75&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08acff75",
  null
  
)

export default component.exports